import { useLogger } from '#imports'

export const usePromotionLogger = () => {
    return useLogger().withTag('@spilnu/promotion')
}
